"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Dialog_1 = require("@mui/material/Dialog");
var DialogTitle_1 = require("@mui/material/DialogTitle");
var DialogContent_1 = require("@mui/material/DialogContent");
var FormGroup_1 = require("@mui/material/FormGroup");
var DialogActions_1 = require("@mui/material/DialogActions");
var Button_1 = require("@mui/material/Button");
var Tree_1 = require("../../../components/Tree");
var EditDriverAction = /** @class */ (function (_super) {
    __extends(EditDriverAction, _super);
    function EditDriverAction(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleChooseDriverPopup = function () {
            _this.setState(function (prevState) { return ({
                showChooseDriverPopup: !prevState.showChooseDriverPopup
            }); });
        };
        _this.navigateToEditDriver = function () {
            var product = _this.props.interaction.product;
            var interactionId = _this.props.policyVersion.interactionId;
            window.location.assign("/journey/show/product/".concat(product, "/process/mtaSupportPortalAnnualEditDriver/editDriver").concat(_this.state.selectedDriverIndex, "EntryPage/").concat(interactionId));
        };
        _this.state = {
            showChooseDriverPopup: false
        };
        _this.onSelectDriver = _this.onSelectDriver.bind(_this);
        return _this;
    }
    EditDriverAction.prototype.render = function () {
        var _a;
        if (!this.props.isMTC && this.props.interaction) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsx)("button", { className: "btn btn-tree", onClick: this.toggleChooseDriverPopup, onKeyDown: this.toggleChooseDriverPopup, children: "Edit driver" }) }), (0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.state.showChooseDriverPopup, onClose: this.toggleChooseDriverPopup, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, { id: "alert-dialog-title", children: "Choose driver to edit" }), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: (0, jsx_runtime_1.jsx)(FormGroup_1.default, { children: (0, jsx_runtime_1.jsxs)("select", { id: "editDriver-select", className: "form-control", value: (_a = this.state.selectedDriverIndex) !== null && _a !== void 0 ? _a : "", onChange: this.onSelectDriver, children: [(0, jsx_runtime_1.jsx)("option", { value: "", disabled: true, children: "Please select..." }), this.props.interaction.additionalDrivers.map(function (driver, index) {
                                                return ((0, jsx_runtime_1.jsxs)("option", { value: index, children: [driver.firstName, " ", driver.lastName] }, driver.personId));
                                            })] }) }) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, { className: "btn", onClick: this.navigateToEditDriver, color: "primary", disabled: this.state.selectedDriverIndex == null, children: "Edit driver" }), (0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.toggleChooseDriverPopup, color: "primary", children: "Cancel" })] })] })] }));
        }
        return null;
    };
    EditDriverAction.prototype.onSelectDriver = function (event) {
        this.setState({
            selectedDriverIndex: Number(event.target.value)
        });
    };
    EditDriverAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Fraud"),
        __metadata("design:paramtypes", [Object])
    ], EditDriverAction);
    return EditDriverAction;
}(React.Component));
exports.default = EditDriverAction;
//# sourceMappingURL=EditDriverAction.js.map